function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box, Image } from 'grommet';
const StyledImage = styled(Image)`
  border-radius: ${props => props.rounded === true ? '100%' : typeof props.rounded === 'string' ? props.rounded : '0%'};
  -webkit-border-radius: ${props => props.rounded === true ? '100%' : typeof props.rounded === 'string' ? props.rounded : '0%'};
  -moz-border-radius: ${props => props.rounded === true ? '100%' : typeof props.rounded === 'string' ? props.rounded : '0%'};
`;
const ImageView = ({
  src,
  size,
  rounded,
  border,
  className,
  ...rest
}) => {
  return /*#__PURE__*/React.createElement(Box, {
    align: "center",
    justify: "center",
    round: rounded === true ? '100%' : typeof rounded === 'string' ? rounded : null,
    width: size,
    height: size,
    border: border,
    className: className
  }, src && /*#__PURE__*/React.createElement(StyledImage, _extends({
    src: src,
    width: size,
    height: size,
    fit: "contain",
    rounded: rounded
  }, rest)));
};
ImageView.defaultProps = {
  size: 'medium',
  border: false
};
ImageView.propTypes = {
  src: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.oneOf(['xxsmall', 'xsmall', 'small', 'medium', 'large', 'xlarge']), PropTypes.string]),
  rounded: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  border: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  className: PropTypes.string
};
export default ImageView;